import React, { useState, useEffect } from 'react';
import '../App.css';
import mapMarker from '@/assets/mapMarker.png';
import phone from '@/assets/phone.png';
import gmailLogo from '@/assets/gmailLogo.png';
import instagramLogo from '@/assets/instagram.png';
import facebookLogo from '@/assets/facebook.png';
import spotifyLogo from '@/assets/spotify.png';
import linkedinLogo from '@/assets/linkedin.png';
import pinterestLogo from '@/assets/pinterest.png';


const Footer = () => {
  const [isPhone, setIsPhone] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsPhone(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  return (
    isPhone ? (
    <footer>
      <div >
        <div className="footer-container-1">
          <hr/>
          <h3 style={{fontWeight: '700', textDecoration: 'underline'}}>Bize Ulaşın</h3>
          
          <div>
          <img src={mapMarker} alt="mapMarker   " />
          <p>İnönü Mahallesi Piri Mehmet Paşa Caddesi No:3/1 Ataşehir/İSTANBUL</p>
          </div>
          <div>
          <img src={phone} alt="phone" />
          <p>0507 437 36 47</p>
          </div>
          <div>
          <img src={gmailLogo} alt="gmailLogo" />
          <p>bilgi@mrsbosscafe.com</p>
          </div>
        </div>
        <hr/>
        <div className="footer-container-2">
          <img src={instagramLogo} alt="instagramLogo" />
          <img src={facebookLogo} alt="facebookLogo" />
          <img src={spotifyLogo} alt="spotifyLogo" />
          <img src={linkedinLogo} alt="linkedinLogo" />
          <img src={pinterestLogo} alt="pinterestLogo" />   
        </div>
      </div>
    </footer>
  ) : (
    <footer style={{maxWidth: '1200px', margin: '0 auto'}}>
      <div >
        <div className="footer-container-1">
          <hr/>
          <h3 style={{fontWeight: '700', textDecoration: 'underline'}}>Bize Ulaşın</h3>
          
          <div>
          <img src={mapMarker} alt="mapMarker   " />
          <p>İnönü Mahallesi Piri Mehmet Paşa Caddesi No:3/1 Ataşehir/İSTANBUL</p>
          </div>
          <div>
          <img src={phone} alt="phone" />
          <p>0507 437 36 47</p>
          </div>
          <div>
          <img src={gmailLogo} alt="gmailLogo" />
          <p>bilgi@mrsbosscafe.com</p>
          </div>
        </div>
        <hr/>
        <div className="footer-container-2">
          <a href="https://www.instagram.com/mrsboss.cafe?igsh=MXB2NGE4ZHo4N3Vtcg=="><img src={instagramLogo} alt="instagramLogo" /></a>
          <a href="https://www.facebook.com/share/19PJLsA8y3/"><img src={facebookLogo} alt="facebookLogo" /></a>
          <a href=""><img src={spotifyLogo} alt="spotifyLogo" /></a>
          <a href=""><img src={linkedinLogo} alt="linkedinLogo" /></a>
          <a href=""><img src={pinterestLogo} alt="pinterestLogo" /></a>   
        </div>
      </div>
    </footer>
  )
  );
};

export default Footer; 